import { useState, useEffect } from 'react';

/** 取得台灣時間 UTC+8 */
function getTaiwanNow(): Date {
  const utc = Date.now() + new Date().getTimezoneOffset() * 60000;
  return new Date(utc + 8 * 3600000);
}

/** 計算距離下一個可領取時間（08:00）的秒數 */
function secondsUntilNextClaim(): number {
  const tw = getTaiwanNow();
  const target = new Date(tw);
  if (tw.getHours() >= 8) {
    target.setDate(target.getDate() + 1);
  }
  target.setHours(8, 0, 0, 0);
  return Math.max(0, Math.floor((target.getTime() - tw.getTime()) / 1000));
}

function pad(n: number) {
  return String(n).padStart(2, '0');
}

interface TokenCountdownProps {
  /** 是否以小卡片樣式呈現（預設 false，行內樣式） */
  card?: boolean;
}

export default function TokenCountdown({ card = false }: TokenCountdownProps) {
  const [secs, setSecs] = useState(secondsUntilNextClaim);

  useEffect(() => {
    const id = setInterval(() => {
      setSecs(secondsUntilNextClaim());
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;

  const isToday8AM = getTaiwanNow().getHours() < 8;
  const label = isToday8AM ? '今日 08:00 可領取' : '明日 08:00 可再領';

  if (card) {
    return (
      <div className="mt-3 flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-50 border border-amber-200">
        <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
          <i className="ri-time-line text-amber-500 text-base"></i>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-amber-700">{label}</p>
          <div className="flex items-center gap-1 mt-1">
            {[{ v: h, u: '時' }, { v: m, u: '分' }, { v: s, u: '秒' }].map(({ v, u }) => (
              <span key={u} className="flex items-baseline gap-0.5">
                <span className="font-black text-lg text-amber-600 tabular-nums leading-none">{pad(v)}</span>
                <span className="text-xs text-amber-400">{u}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 text-xs text-amber-700 font-medium">
      <div className="w-4 h-4 flex items-center justify-center">
        <i className="ri-time-line text-amber-500"></i>
      </div>
      <span>{label}：</span>
      <span className="font-black tabular-nums text-amber-600">
        {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </div>
  );
}
